import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSlideshareComponent } from './simple-icons-slideshare.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSlideshareComponent ],
    exports:      [ SimpleIconsSlideshareComponent ],
    bootstrap:    []
})
export class SimpleIconsSlideshareModule {}
